"use client";

import { faCheck, faDotCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import { type ReactNode, forwardRef } from "react";
import { Link, type LinkProps } from "~/components/Link";
import type { RenderMode } from "./FilterOptions";

export interface FilterItemOptionProps extends Omit<LinkProps, "title"> {
	title?: ReactNode;
	count?: number | null;
	mode?: RenderMode;
	isActive?: boolean;
}

export const FilterItemOption = forwardRef<HTMLAnchorElement, FilterItemOptionProps>(
	function FilterItemOptionRef(props, ref) {
		const { title, count, isActive = false, mode = "check", ...remainingProps } = props;

		if (mode === "grid") {
			return (
				<Link
					ref={ref}
					{...remainingProps}
					className={cn(
						"flex items-center justify-center border hover:border-primary-medium focus:outline-none focus-visible:border-primary-medium",
						{
							"border-primary-medium bg-primary-medium text-white": isActive,
							"border-shades bg-white p-1 text-dark": !isActive,
						},
					)}
				>
					{typeof title === "string" ? <div dangerouslySetInnerHTML={{ __html: title }} /> : title}
				</Link>
			);
		}

		return (
			<Link
				ref={ref}
				{...remainingProps}
				className="group flex w-full snap-start items-center py-2 first:pt-0 last:pb-3 focus:outline-none"
			>
				<div className="flex grow items-center justify-between text-left">
					{typeof title === "string" ? (
						<div
							className="mr-2 group-hover:underline group-focus-visible:underline"
							dangerouslySetInnerHTML={{ __html: title }}
						/>
					) : (
						title
					)}

					{!!count && <div className="text-shades-dark text-sm">{count}</div>}
				</div>

				<div
					className={cn("ml-4 flex h-6 w-6 items-center justify-center overflow-hidden border", {
						rounded: mode === "check",
						"rounded-full": mode === "radio",

						"bg-primary-medium": isActive && mode === "check",

						"border-primary-medium ": isActive,
						"border-shades": !isActive,
					})}
				>
					{isActive && (
						<FontAwesomeIcon
							size="sm"
							icon={mode === "check" ? faCheck : faDotCircle}
							className={cn("block h-5 w-5", {
								"text-white": mode === "check",
								"text-primary-medium": mode === "radio",
							})}
						/>
					)}
				</div>
			</Link>
		);
	},
);
